import { useQuery } from '@tanstack/react-query';
import { fetchShipmentLocationTypesList } from '../../data-provider/select-options';

export const useGetShipmentLocationTypes = () => {
  return useQuery({
    queryKey: ['shipment-location-types'],
    queryFn: () => fetchShipmentLocationTypesList(),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
